import React from "react";
import "./Game.css";

var intermediate = "https://static.igem.wiki/teams/4888/wiki/game/tutorial.png";

function changeImage(id, to_change) {
  intermediate = document.getElementById(id).src;
  document.getElementById(id).src = document.getElementById(to_change).src;
  document.getElementById(to_change).src = intermediate;

  intermediate = document.getElementById(id).alt;
  document.getElementById(id).alt = document.getElementById(to_change).alt;
  document.getElementById(to_change).alt = intermediate;

  if (to_change === "imgClickAndChange") {
    document.getElementById("caption").textContent =
      document.getElementById(to_change).alt;
  }
}

function applyImage(id, to_change) {
    document.getElementById(to_change).src = document.getElementById(id).src;

    document.getElementById(to_change).alt = document.getElementById(id).alt;
    document.getElementById("caption_collab").textContent = document.getElementById(id).alt;
}

const Article = () => {
  return (
    <div className="mb-20">
      <h2 id="Introduction"> Introduction </h2>
      <hr className="dividergeneral mb-5"></hr>
      <p className="mb-2">
        Education through entertainment is one of the most effective ways to
        learn, we thus wanted to promote synthetic biology in a fun and
        interactive way. It is essential to
        reach as many people as possible, regardless of their age or background.
              That is why we decided, after discussion with people in
        our field as well as with teenagers and other people of the general
        people to create a video game: BioQuest.
      </p>
      <p className="mb-2">
        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/game/bioquest-promo.png"
              style={{
                paddingTop: "30px",
                paddingBottom: "30px",
                width: "50%",
                height: "auto",
              }}
              alt="bioquest logo - a game about synthetic biology"
            />
          </center>
        </figure>
      </p>
      <p className="mb-2">
        BioQuest is a game aimed at promoting the main concepts of synthetic
        biology and lab work to the public.
      </p>
      <br />
      <p className="mb-2">The game is divided into two different parts: </p>

      <p className="mb-2">
        <ul className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}>
          <li>
            <mark>
              <b>The main game</b>
            </mark> 
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The main game takes the player into the discovery of some of
              synthetic biology’s main advancement (such as GFP, ampicillin…)
              through 48C’s project: catching cadmium. The player will embody a
              bacterium trying to safely navigate the human body to catch cadmium
              contained in the body before exiting it. At each level, the
              bacterium will face challenges that can be solved by combining a
              number of plasmids and genes that will help it survive its current
              environment.
            </p>
          </li>

          <li>
            <mark>
              <b>The minigames</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              Fifteen different minigames will take the player through lab work
              and safety as well as some biological concepts. Each minigame
              provides some explanation of the lesson it is trying to teach the
              player. Minigames aim to foster curiosity about biology.
            </p>
          </li>
        </ul>
      </p>
      <h2 className="mt-20" id="Design"> Design choices </h2>
      <hr className="dividergeneral mb-20"></hr>
      <figure>
        <center>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/game/menu-1.png"
            style={{ paddingTop: "30px", width: "50%", height: "auto" }}
            alt="main menu of bioquest"
            id="menu1"
          />
          <i>
            <figcaption id="menu">Main menu of bioquest</figcaption>
          </i>
          <br />
        </center>
      </figure>
      <p className="mb-2">
        We opted for a straightforward game design to avoid clutter and
        unnecessary complexity, allowing us to concentrate on conveying our
        intended message effectively while maintaining an appealing visual
        appearance, with the main game’s design being inspired by pixel art. The
        entirety of the game’s graphics was created by the team. The music used
        in the game is free of use to avoid copyright.
      </p>
      <p className="mb-2">
        The game was coded using Godot, a software created for game design using
        its own language GDScript.
      </p>
      <p className="mb-2">
        We've made BioQuest accessible to a broad audience by ensuring
        compatibility with both MacOS and Windows, thereby maximizing the number
        of people who can enjoy the game.
      </p>
      <h2 className="mt-20" id="Main Game"> Main Game </h2>
      <hr className="dividergeneral mb-5"></hr>
      <p className="mb-2">
        The main game principle is simple: at each level, the bacteria will have
        to face a challenge, either a typical synthetic biology challenge such
        as surviving in the presence of ampicillin or shining under UV light, or
        a more complex and specific one, such as binding to the mucus of the
        intestine while avoiding acid.
      </p>
      <p className="mb-2">
        It is required to pass the level in the right order, as you will
        discover new genes and elements along the way, allowing you to construct
        the right plasmid necessary to fulfill the ultimate goal of the main
        game: removing cadmium from the intestine and leaving it intact.
      </p>
      <p className="mb-2">
        <center className="mb-5">
          <h3> click on the small images ! </h3>
        </center>

        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/game/tutorial.png"
              style={{ paddingTop: "30px", width: "50%", height: "auto" }}
              alt="Tutorial window"
              id="imgClickAndChange"
            />
            <i>
              <figcaption id="caption">
                Bioquest - a game about synthetic biology
              </figcaption>
            </i>
          </center>
        </figure>

              <table width="100%">
                  <tr>
            <td align="left">
              <img
                src="https://static.igem.wiki/teams/4888/wiki/game/build.png"
                alt="Build window"
                id="image1"
                onClick={() => changeImage("image1", "imgClickAndChange")}
              />
            </td>
            <td align="center">
              <img
                src="https://static.igem.wiki/teams/4888/wiki/game/encyclopedia.png"
                alt="Encyclopedia window"
                id="image2"
                onClick={() => changeImage("image2", "imgClickAndChange")}
              />
            </td>
            <td align="right">
              <img
                src="https://static.igem.wiki/teams/4888/wiki/game/victory.png"
                alt="Win window"
                id="image3"
                onClick={() => changeImage("image3", "imgClickAndChange")}
              />
                      </td>
                      </tr>
        </table>
      </p>
      <p className="mb-2">The screen of the main game is composed of the following elements:</p>
      <p className="mb-2">
        <ul className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}>
          <li>
            <mark>
              <b>The main window</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The bacterium needs to travel along the window while facing
              obstacles. A limited price is available to the player to compose
              its plasmids to ensure that the player cannot simply add every
              plasmid available to them.
            </p>
          </li>
          <li>
            <mark>
              <b>The Edit button</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The edit button takes the player to the genes available to them to
              construct their plasmid.
            </p>
          </li>
          <li>
            <mark>
              <b>The ? button</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The ? button takes the player to the plasmids their bacteria
              already possess.
            </p>
          </li>
          <li>
            <mark>
              <b>The Help button</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The Help button will give a hint to the player if hey have issues
              passing the level they are playing.
            </p>
          </li>
          <li>
            <mark>
              <b>The Encyclopedia button</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              This button will open a library containing any obstacles that the
              player has faced with the obstacle’s description.
            </p>
          </li>
          <li>
            <mark>
              <b>The play/stop button</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The player needs to press this button to make the bacteria start
              and stop its journey.
            </p>
          </li>
        </ul>
      </p>
          <p className="mb-20">You can find a playthrough of the game on IGEM software. You can find a video of the tutorial below (accelerated)</p>

          <p className="mb-2">
              <figure>
                  <center>
                      <img
                          src="https://static.igem.wiki/teams/4888/wiki/tutorial-xk8tsjb4.gif"
                          style={{
                              paddingTop: "30px",
                              paddingBottom: "30px",
                              width: "75%",
                              height: "auto",
                          }}
                          alt="tutorial of bioquest"
                      />
                      <i>
                          <figcaption id="menu">Tutorial of bioquest</figcaption>
                      </i>
                  </center>
              </figure>
          </p>
      <p className="mb-2">Here are some images of a few levels of the game:</p>
      <html>
        <center className="mb-5">
          <h3> click on the small images ! </h3>
        </center>

        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/game/level1.png"
              style={{ paddingTop: "30px", width: "50%", height: "auto" }}
              alt="level1"
              id="maingames"
            />
            <i>
              <figcaption id="minicaption">
                Bioquest - various levels
              </figcaption>
            </i>
            <br />
          </center>
        </figure>
        <head>
          <link rel="stylesheet" href="game.css"></link>
        </head>

        <body>
          <div class="image-slider">
            <div class="image-slider-track-1">
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/level2.png"
                  alt="level2"
                  id="level2"
                  onClick={() => changeImage("level2", "maingames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/level3.png"
                  alt="level3"
                  id="level3"
                  onClick={() => changeImage("level3", "maingames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/level4.png"
                  alt="level4"
                  id="level4"
                  onClick={() => changeImage("level4", "maingames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/level5.png"
                  alt="level5"
                  id="level5"
                  onClick={() => changeImage("level5", "maingames")}
                ></img>
              </div>
            </div>
          </div>
        </body>
      </html>
      <h2 className="mt-20" id="Mini-Games"> Mini-Games </h2>
      <hr className="dividergeneral mb-5"></hr>
      <p className="mb-20">
        {" "}
        The minigames are centered around daily lab life such as vortexing a 1,5
        ml tube, putting on the correct lab attire, making a western-blot,
        balancing a centrifuge... . They are destined for a large public range.
      </p>
      <p className="mb-2">
        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/game/minimenu-1.png"
              style={{ paddingTop: "30px", width: "50%", height: "auto" }}
              alt="minigames menu of bioquest"
              id="menu2"
            />
            <i>
              <figcaption id="minimenu">minimages menu of bioquest</figcaption>
            </i>
          </center>
        </figure>
      </p>
      <p className="mb-2">Three modes are available to play the minigames.</p>
      <p className="mb-2">
        <ul className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}>
          <li>
            <mark>
              <b>Single game mode</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The player chooses a specific game and plays. As you win, the game
              will become significantly harder.
            </p>
          </li>
          <li>
            <mark>
              <b>Survival mode</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              The games are displayed in a random order. The rules to every game
              still appear in between each game and the player can choose when
              to start and pause the game. The player gains a point each time
              they win a game, when they lose and start again, the score starts
              back from zero.
            </p>
          </li>
          <li>
            <mark>
              <b>Extreme survival mode</b>
            </mark>
            <p className="mb-2" style={{ marginLeft: "50px" }}>
              It is a speed game! The player must win each game without error
              and gains a point each time they win a game.The top players are
              ranked in the menu.
            </p>
          </li>
        </ul>
      </p>
      <p className="mb-2">
        You can find on our scrolling images, different mini-games that our
        destined for teenagers and the general public.
      </p>
      <html>
        <center className="mb-5">
          <h3> click on the small images to change ! </h3>
        </center>

        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/game/game3.png"
              style={{ paddingTop: "30px", width: "50%", height: "auto" }}
              alt="game3"
              id="minigames"
            />
            <i>
              <figcaption id="minicaption">
                Bioquest - a lot of minigames
              </figcaption>
            </i>
          </center>
        </figure>
        <head>
          <link rel="stylesheet" href="game.css"></link>
        </head>

        <body>
          <div class="image-slider">
            <div class="image-slider-track-2">
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game1.png"
                  alt="game1"
                  id="game1"
                  onClick={() => changeImage("game1", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game2.png"
                  alt="game2"
                  id="game2"
                  onClick={() => changeImage("game2", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game4.png"
                  alt="game4"
                  id="game4"
                  onClick={() => changeImage("game4", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game5.png"
                  alt="game5"
                  id="game5"
                  onClick={() => changeImage("game5", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game6.png"
                  alt="game6"
                  id="game6"
                  onClick={() => changeImage("game6", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game7.png"
                  alt="game7"
                  id="game7"
                  onClick={() => changeImage("game7", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game8.png"
                  alt="game8"
                  id="game8"
                  onClick={() => changeImage("game8", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game9.png"
                  alt="game9"
                  id="game9"
                  onClick={() => changeImage("game9", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game10.png"
                  alt="game10"
                  id="game10"
                  onClick={() => changeImage("game10", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game11.png"
                  alt="game11"
                  id="game11"
                  onClick={() => changeImage("game11", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game12.png"
                  g
                  alt="game12"
                  id="game12"
                  onClick={() => changeImage("game12", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game13.png"
                  alt="game13"
                  id="game13"
                  onClick={() => changeImage("game13", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game14.png"
                  alt="game14"
                  id="game14"
                  onClick={() => changeImage("game14", "minigames")}
                ></img>
              </div>
              <div class="slide">
                <img
                  src="https://static.igem.wiki/teams/4888/wiki/game/game15.png"
                  alt="game15"
                  id="game15"
                  onClick={() => changeImage("game15", "minigames")}
                ></img>
              </div>
            </div>
          </div>
        </body>
      </html>
      <h2 className="mt-20" id="Collaboration"> Collaboration </h2>
      <hr className="dividergeneral mb-5"></hr>
      <p className="mb-2">
        We designed the game hoping it could also be a tool for future iGEM
        teams to communicate in an entertaining way the challenges they
        face to a broad population.
      </p>
      <p className="mb-2">
        To do so, we commented on all the code to give them the possibility to
        understand how the game operates. In addition, you can find in the
        references a bunch of ressources to start with Godot.
      </p>
      <p className="mb-2">
        We added a template of one of the levels for the minigames and the main
        game. The code is commented and the template allows for the creation of
        a new level and its addition to the game.
      </p>
      <p className="mb-20">
        Finally, we wanted to show the flexibility of our game and his potential
        by making levels not only about our game but also about other iGEM
        projects! We contacted other iGEM teams to collaborate by adding a
        level. The game was advertised on social media.
      </p>
      <p className="mb-2">
        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/game/video-game.gif"
              style={{ paddingTop: "30px", width: "40%", height: "auto" }}
              alt="presentation on social media"
            />
            <i>
              <figcaption>Presentation of the game on instagram</figcaption>
            </i>
          </center>
        </figure>
      </p>
      <p className="mb-20">
              We collaborated with the Thessaloniki IGEM team to add a level and a
              minigame. This team work on a hydrogel to spread on the soil after a
              wildfire, to rehydrate it and help the recovery. <br />
        The team worked on encapsulation of two different
        strains of bacteria in the hydrogel. We used this concept to contruct a minigame.
        <br />
        For the level, we worked on corum sensing. In their project, the two
        strain communicate with each other using a corum sensing method, that
        the team enginnered using synthetic biology.
      </p>
      <p className="mb-2">
        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/game/collab.png"
              style={{ paddingTop: "30px", width: "50%", height: "auto" }}
              alt="The minigame of the team Thessaloniki"
            />
            <i>
              <figcaption>
                The minigame of the team Thessaloniki : catch the bacterias in
                the hydrogel !
              </figcaption>
            </i>
          </center>
        </figure>
          </p>
          <figure>
          <figure>
              <center>
                  <img
                      src="https://static.igem.wiki/teams/4888/wiki/game/collab1.png"
                      style={{ paddingTop: "30px", paddingBottons: "50px", width: "450px", height: "300px" }}
                      alt="The level start with two bacteria strains"
                      id="collab"
                  />
                  <i>
                      <figcaption id="caption_collab">
                          The level start with two bacteria strains
              </figcaption>
                  </i>
              </center>
          </figure>

          <table width="100%">
              <tr>
                  <td align="left">
                      <img
                          src="https://static.igem.wiki/teams/4888/wiki/game/collab1.png"
                          alt="The level start with two bacteria strains"
                          id="collab1"
                          onClick={() => applyImage("collab1", "collab")}
                      />
                  </td>
                  <td align="center">
                      <img
                          src="https://static.igem.wiki/teams/4888/wiki/game/collab2.png"
                          alt="The first strain communicate via corum sensing"
                          id="collab2"
                          onClick={() => applyImage("collab2", "collab")}
                      />
                  </td>
                  <td align="right">
                      <img
                          src="https://static.igem.wiki/teams/4888/wiki/game/collab3.png"
                          alt="The second strain produce a biofertiliser on command"
                          id="collab3"
                          onClick={() => applyImage("collab3", "collab")}
                      />
                  </td>
              </tr>
              </table>
              <i><center>
                  <figcaption >
                      The level of the team Thessaloniki : corum sensing and treatment of the soil after a wildfire.
              </figcaption>
                  </center></i>
          </figure>
          <br/>
          <p className="mb-20">
              When the game was finished, our objective was to gather
              feedback from individuals with diverse backgrounds and make it easily accessible. To achieve this,
              we established a Google Drive where users could access the game, and we promoted it through social media.
      </p>
          <p className="mb-2">
              <figure>
                  <center>
                      <img
                          src="https://static.igem.wiki/teams/4888/wiki/game/final-promotion.gif"
                          style={{ paddingTop: "30px", width: "40%", height: "auto" }}
                          alt="advertisement on social media"
                      />
                      <i>
                          <figcaption>Ask for beta tester on instagram</figcaption>
                      </i>
                  </center>
              </figure>
          </p>
          <h2 className="mt-20" id="Download"> Want to play ?  </h2>
          <hr className="dividergeneral mb-5"></hr>
          <p className="mb-2">
              You now have all the necessary information to play the game. You can find it on the <a href="https://gitlab.igem.org/2023/software-tools/epfl"> IGEM software Gitlab repository</a>.
              <br /> The Git repository contains the .godot file, all the files required to build the game, and a README guide that explains how to build and run the game using GODOT. 
              <br />
              The README also offers insights into game design, code, and instructions on how to utilize the template effectively.
              This resource not only enables gameplay but also facilitates easy modifications for future IGEM teams.
              You can also access the PDF of the readme below for your convenience.
      </p>
          <p className="mb-2"><br/>
          <details>
              <summary>
                  <mark>
                      <b>PDF of the game</b>
                  </mark>
              </summary>
              <object
                      data="https://static.igem.wiki/teams/4888/wiki/game/readme.pdf"
                  width="800"
                  height="500"
                  aria-label="Flask Clamp PDF Document"
              />
              </details>
          </p><br />
          <p className="mb-2">
              Additionally, we are offering a link to the drive where you can access the app version of the game that we have provided for users:  <a href="https://drive.google.com/drive/folders/1H-4W0A03qS9c02kNHEzeER4AwsEUCHcr?usp=drive_link"> Bioquest Drive</a>.
      </p><br />
      <h2 className="mt-20" id="references"> References </h2>
      <hr className="dividergeneral mb-5"></hr>
      <ul>
        <ol type="1">
          <li id="ref1">
            Godot <br />{" "}
            <a href="https://godotengine.org/">
              {" "}
              Godot : a free, all-in-one, cross-platform game engine{" "}
            </a>{" "}
          </li>
          <li id="ref2">
            {" "}
            Godot tutorial platform
            <br /> <a href="https://godottutorials.com/">
              {" "}
              Godot tutorials{" "}
            </a>{" "}
          </li>
          <li id="ref3">
            {" "}
            Godot online crash course
            <br />{" "}
            <a href="https://www.youtube.com/watch?v=S8lMTwSRoRg">
              {" "}
              Godot Game Development – Crash Course for Beginners{" "}
              freeCodeCamp.org, 2023
            </a>{" "}
          </li>
          <li id="ref4">
            {" "}
            Godot online course
            <br />{" "}
            <a href="https://www.youtube.com/watch?v=42HKCFf5Lf4&list=PLhqJJNjsQ7KEcm-iYJ2a8UCRN62bTneKa">
              {" "}
              Getting Started with the Godot Game Engine in 2021 GDQuest, 2021
            </a>{" "}
          </li>
          <li id="ref4">
            {" "}
            Thessaloniki team
            <br />{" "}
            <a href="https://2023.igem.wiki/thessaloniki/">
              {" "}
              Thessaloniki wiki{" "}
            </a>{" "}
          </li>
        </ol>
      </ul>
      <br />
    </div>
  );
};

export default Article;
